import { useCallback } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { ButtonsWrapper } from "src/styled";
import { MEDLBID } from "src/utils";

import ExportButton from "./ExportButton";
import PDFButton from "./PDFButton";

interface Props {
  disabled: boolean;
  watchData: Record<string, any>;
}

const SearchHeader = ({ disabled, watchData }: Props) => {
  const { collectionId } = useParams();
  const [searchParams] = useSearchParams();

  const getLinks = useCallback(() => {
    const type = searchParams.get("type");
    const links = [{ title: "Home", href: "/home" }];
    if (collectionId) {
      if (type === "colid") {
        links.push({
          title: "Collection",
          href: `/collection/${collectionId}`,
        });
      } else {
        links.push({
          title: "Logbook",
          href: `/logbook/${collectionId}/${type}`,
        });
      }
    }
    let href = "/search";
    if (collectionId) href += `/${collectionId}`;
    if (type) href += `?type=${type}`;
    links.push({
      title: "Search",
      href,
    });
    return links;
  }, [collectionId, searchParams]);

  return (
    <Breadcrumbs
      border={false}
      customLinks={getLinks()}
      style={{ marginBottom: 10 }}>
      <ButtonsWrapper>
        {collectionId === MEDLBID && <ExportButton />}
        <PDFButton filters={watchData} disabled={disabled} />
      </ButtonsWrapper>
    </Breadcrumbs>
  );
};

export default SearchHeader;
